import { Grow, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { ObtenerEvidencias } from '../../helpers/AsuntosHelper';

export const EvidenciasComponent = ({avance}) => {
    const [evidencias, setEvidencias] = useState([]);

    const obtenerEvidencias = () => {
        ObtenerEvidencias(avance).then(datos => setEvidencias(datos));
    }

    useEffect(() => {
        obtenerEvidencias();
    }, [avance])
    

  return (
    <div
        style={{
            display:'flex',
            flexDirection:'row',
            overflowX:'auto'
        }}
    >
    {
        evidencias?.map(evidencia => (
            <Grow key={evidencia.IdEvidencia} in={true} timeout={2000}>
            <div
                style={{
                    margin:10,
                }}
            >
                <Tooltip placement='top' title={
                    <img
                    style={{
                        maxWidth:600,

                    }}
                    src={evidencia}
                    loading="lazy"
                />
                } >
                    <img
                        style={{
                            maxWidth:150,
                            borderRadius:10

                        }}
                        src={evidencia}
                        loading="lazy"
                    />
                </Tooltip>
            </div>
            </Grow>
        ))
    }
    </div>
  )
}
